import Toggle from '../toggle/Toggle';
import FilterContainer from './FilterContainer';
import { useFilterContext } from './hooks';
import { ToggleFilterConfig } from './types';

type ToggleFilterProps = {
    title: string;
    id: string;
};

function ToggleFilter({ title, id }: ToggleFilterProps): JSX.Element {
    const filterInstance = useFilterContext();
    const filter = filterInstance.getFilterSection<ToggleFilterConfig>(id);

    return (
        <FilterContainer
            title={title}
            activeFilterCount={filterInstance.getActiveFilterCount(id)}
            isOpen={filterInstance.getActiveFilterCount(id) > 0}
        >
            <div className="p-2">
                <Toggle
                    onToggle={(enabled): void => filterInstance.updateToggleOption(id, enabled)}
                    type="short"
                    defaultEnabled={filter?.option.active}
                />
            </div>
        </FilterContainer>
    );
}

export default ToggleFilter;
